import React, { useState, useEffect, useRef } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { HiGlobeAlt } from 'react-icons/hi';

const LanguageSwitcher = () => {
  const { language, changeLanguage } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const languages = [
    { code: 'en', name: 'English', flag: '🇬🇧' },
    { code: 'nya', name: 'Nyanja', flag: '🇿🇲' },
    { code: 'ny', name: 'Chichewa', flag: '🇿🇲' },
    { code: 'bem', name: 'Bemba', flag: '🇿🇲' },
    { code: 'toi', name: 'Tonga', flag: '🇿🇲' },
    { code: 'fr', name: 'Français', flag: '🇫🇷' },
    { code: 'pt', name: 'Português', flag: '🇵🇹' },
  ];

  const currentLang = languages.find(l => l.code === language) || languages[0];

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div
      ref={dropdownRef}
      data-tour="language-switcher"
      style={{ position: 'relative', display: 'inline-block' }}
    >
      <button
        onClick={() => setIsOpen(!isOpen)}
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '0.4rem',
          background: 'transparent',
          border: '2px solid var(--primary)',
          color: 'var(--text-dark)',
          padding: '0.4rem 0.8rem',
          borderRadius: '8px',
          cursor: 'pointer',
          fontSize: '0.9rem',
          fontWeight: '500',
          transition: 'var(--transition)',
        }}
        onMouseOver={(e) => {
          e.currentTarget.style.background = 'var(--primary)';
          e.currentTarget.style.color = 'white';
        }}
        onMouseOut={(e) => {
          e.currentTarget.style.background = 'transparent';
          e.currentTarget.style.color = 'var(--text-dark)';
        }}
      >
        <HiGlobeAlt size={18} style={{ pointerEvents: 'none' }} />
        <span style={{ pointerEvents: 'none' }}>{currentLang.flag} {currentLang.code.toUpperCase()}</span>
      </button>

      {isOpen && (
        <div
          style={{
            position: 'absolute',
            top: '110%',
            right: 0,
            background: 'white',
            borderRadius: '10px',
            boxShadow: 'var(--shadow-lg)',
            padding: '0.5rem 0',
            minWidth: '160px',
            zIndex: 1000,
          }}
        >
          {languages.map((lang) => (
            <button
              key={lang.code}
              onClick={() => {
                changeLanguage(lang.code);
                setIsOpen(false);
              }}
              style={{
                width: '100%',
                textAlign: 'left',
                padding: '0.6rem 1rem',
                background: language === lang.code ? 'rgba(0, 173, 181, 0.1)' : 'transparent',
                border: 'none',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                gap: '0.6rem',
                fontSize: '0.9rem',
                color: 'var(--text-dark)',
                transition: 'var(--transition)',
              }}
              onMouseOver={(e) => {
                if (language !== lang.code) {
                  e.currentTarget.style.background = 'rgba(0, 173, 181, 0.05)';
                }
              }}
              onMouseOut={(e) => {
                if (language !== lang.code) {
                  e.currentTarget.style.background = 'transparent';
                } else {
                  e.currentTarget.style.background = 'rgba(0, 173, 181, 0.1)';
                }
              }}
            >
              <span style={{ pointerEvents: 'none' }}>{lang.flag}</span>
              <span style={{ pointerEvents: 'none' }}>{lang.name}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSwitcher;

